import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TableauService } from '@shared/services/tableau.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as Tableau from 'tableau-api-js';

@Component({
  selector: 'app-tableau-dialog',
  templateUrl: './tableau-dialog.component.html',
  styleUrls: ['./tableau-dialog.component.scss'],
})

export class TableauDialogComponent implements OnInit {
  tableauId: number = 0;
  title: string = '';
  message: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private tableauService: TableauService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<TableauDialogComponent>
  ) {
    if (data) {
      this.tableauId = data.tableauId || this.tableauId;
      this.title = data.title || this.title;
      this.message = data.message || this.message;
    }
  }
  @Input() token = '';

  public ngOnInit(): void {
    this.getToken();
    this.initViz();
  }

  public copyUrl() {
    const url = `${window.location.origin}/reports?dashboard=${this.tableauId}`;
    this.clipboard.copy(url);
  }

  public async getToken() {
    const vizToken = await this.tableauService.get();
    this.token = vizToken.token;
  }

  public initViz(): void {
    const containerDiv = document.getElementById('vizContainer');
    containerDiv.innerHTML = this.message;
  }
}
